module.exports = __webpack_public_path__ + "img/process_4.370420f1.svg";